import NewApiService from "@/utils/new.api.service";

export default {
    setCustomerMail({commit}, email){
        commit('setCustomerMail', email)
    },
    createCustomer({commit, state}) {
        return new Promise((resolve, reject) => {
            NewApiService.post(`pos/create-customer`, {email: state.email})
                .then(({data}) => {
                    commit("setClient", data.client)
                    resolve(data)
                })
                .catch(({response}) => {
                    reject(response.data)
                })
        })
    },
    setPaymentType({commit}, paymentType) {
        commit('setPaymentType', paymentType)
    },
    applyPayout({commit, state}){
        return new Promise((resolve, reject) => {
            NewApiService.post(`pos/${state.order.id}/apply-payout`, {paymentType: state.paymentType})
                .then(({data}) => {
                    commit("setOrder", data.order)
                    resolve(data)
                })
                .catch(({response}) => {
                    reject(response.data)
                })
        })
    },

    createInvoice({commit, state}){
        return new Promise((resolve, reject) => {
            NewApiService.post("pos/"+state.order.id+"/create-invoice")
            .then(({data}) => {
                commit("setOrder", data.order)
                resolve(data)
            })
            .catch(({response}) => {
                reject(response.data)
            })
        })
    },

    saveOrder({state, commit}){
        let endpoint = "pos/create-order";
        return new Promise((resolve, reject) => {
            NewApiService.post(endpoint, {
                cart:state.cart,
                clientId:state.clientId,
                posOptions:state.posOptions,
            })
            .then(({data}) => {
                commit("setOrder", data.order)
                resolve(data)
            })
            .catch(({response}) => {
                reject(response.data)
            })
        })
    },

    addToCart(context, {product, quantity}){
        let row = context.state.cart.find(row => row.id == product.id)
        if(row){
            if(row.quantity+quantity > product.stock){
                context.dispatch("app/displaySnackBar", {text:"Stock unvailable for product : "+product.name, color:'red darken-3'},{root:true})
                return;
            }
            context.commit("changeQuantity", {row, change: quantity})
        }else{
            if(product.stock == 0){
                context.dispatch("app/displaySnackBar", {text:"Stock unvailable for product : "+product.name, color:'red darken-3'},{root:true})
                return;
            }
            row = {
                id:product.id,
                product:product,
                quantity:quantity,
                unitPrice:context.getters.getPrice(product)
            }
            context.commit("addToCart",row)
        }
    },
    async setClient({commit, dispatch}, clientId){
        let client = null
        if(clientId){
            client = await dispatch("clients/view",{id:clientId},{root:true})
        }
        commit("setClient", client)
    },
    deleteRow(context, row){
        context.commit("deleteRow", row)
    },
    changeQuantity(context, {row, change}){
        if(row.quantity + change > row.product.stock ){
                context.dispatch("app/displaySnackBar", {text:"Stock unvailable for product : "+row.name, color:'red darken-3'},{root:true})
            return;
        }
        context.commit("changeQuantity", {row, change})
    },
    cancelOrder(context, params){
        return new Promise((resolve, reject) => {
            NewApiService.post("pos/"+context.state.order.id+"/cancel", params)
            .then(({ data }) => {
                context.commit("cleanOrder")
                resolve(data);
            })
            .catch(({response}) => {
                reject(response.data)
            })
          });
        // Cancel order in server to cancel reservation too
    },
    cleanOrder(context){
        context.commit("cleanOrder")
    },
    cleanCart(context){
        context.commit("cleanCart")
    },
    async convertOrder({commit, dispatch}, order){
        commit("cleanCart")
        commit("setOrder", order)
        if(order.rows && order.rows.length){
            order.rows.forEach(async row => {

                const product = await dispatch("products/get",{id:row.productId},{root:true})

                commit("addToCart",{
                    id:row.productId,
                    product:product.data,
                    unitPrice: row.unitPrice,
                    quantity:row.quantity,
                })
            });
        }
        dispatch("setClient",order.clientId)
    },
    setProducts(context, products){
        const categories = products.reduce((cat, product) => {
            if(!cat.includes(product.type.toLowerCase())){
                cat.push(product.type.toLowerCase())
            }
            return cat
        }, [])
        context.commit("setProducts", products)
        context.commit("setCategories", categories)
    },
    setTaxRate(context, taxRate){
        context.commit("setTaxRate", taxRate)
    },
    setCatalog(context, catalogId){
        context.commit("setCatalog", catalogId)
    },


}